import { showCustomToast } from "../../utils/toastUtil";
import React, { useState } from "react";
import axios from "axios";

export const Settings = () => {
  // =======================
  // Admin Authentication
  // =======================
  const userObj = localStorage.getItem("salla_discourse_user");
  const user = JSON.parse(userObj);
  let username;
  let user_id;
  if (user) {
    username = user.username;
    // eslint-disable-next-line no-unused-vars
    user_id = user.id;
  }

  // =======================
  // useStates
  // =======================
  const [name, setName] = useState(user.name ?? "");
  const [bio, setBio] = useState(user.bio_raw ?? "");
  const [website, setWebsite] = useState(user.website ?? "");
  const [sallaStoreName, setSallaStoreName] = useState(
    user?.user_fields[1] ?? ""
  );
  const [sallaStoreUrl, setSallaStoreUrl] = useState(
    user?.user_fields[2] ?? ""
  );
  const [twitter, setTwitter] = useState(user?.user_fields[3] ?? "");
  const [instagram, setInstagram] = useState(user?.user_fields[4] ?? "");
  const [tiktok, setTiktok] = useState(user?.user_fields[5] ?? "");
  const [image, setImage] = useState(
    `${user.avatar_template.replace("{size}", "200")}`
  );
  const [uploadId, setUploadId] = useState(undefined);

  // =======================
  // APIs
  // =======================s
  const updateUserDetails = async () => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("bio_raw", bio);
      formData.append("website", website);
      formData.append("user_fields[1]", sallaStoreName);
      formData.append("user_fields[2]", sallaStoreUrl);
      formData.append("user_fields[3]", `${twitter}`);
      formData.append("user_fields[4]", `${instagram}`);
      formData.append("user_fields[5]", `${tiktok}`);

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/u/${encodeURIComponent(
          username
        )}.json`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const user = response.data.user;

      if (uploadId) {
        const body = {
          upload_id: uploadId,
          type: "uploaded",
        };
        await axios.put(
          `${process.env.REACT_APP_API_URL}/u/${encodeURIComponent(
            username
          )}/preferences/avatar/pick.json`,
          body
        );
        user.avatar_template = image;
      }
      localStorage.setItem("salla_discourse_user", JSON.stringify(user));

      showCustomToast("تم تحديث الإعدادات بنجاح", "success");
    } catch (err) {
      const errors = err?.response?.data?.errors;
      errors?.forEach((error) => {
        showCustomToast(error, "error");
      });
    }
  };

  // =======================
  // handlers
  // =======================
  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/heic",
        "image/heif",
        "image/webp",
        "image/avif",
      ];

      if (!allowedTypes.includes(file.type)) {
        showCustomToast(
          "الملف الذي حاولت رفعة غير مدعم الرجاء اختيار احد الأمتدادات التالية : (jpg, jpeg, png, gif, heic, heif, webp, avif)",
          "error"
        );
        return;
      }

      if (file.size > 8000000) {
        showCustomToast("الرجاء اختيار صورة بحد اقصي 5 ميقا بايت", "error");
        return;
      }

      let formData = new FormData();
      formData.append("type", "avatar");
      formData.append("synchronous", true);
      formData.append("file", file);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploads.json`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setUploadId(response.data.id);
      setImage(response.data.url);
    } catch (err) {
      // showCustomToast(`${err.response?.data?.errors?.[0]}`, "error");
      console.error(err);
    }
  };

  return (
    <div className="w-full flex justify-center">
      <div
        className="flex flex-col justfy-center items-center w-[700px] gap-[20px] pb-[100px]"
        dir="rtl"
      >
        <div className="start justify-end w-full">
          <div className="h-[224px] flex items-center relative">
            <img
              src={image}
              alt="avatar"
              className="w-[124px] h-[124px] mr-3 sm:mr-0 rounded-full"
              onError={(e) => {
                e.target.src = `${process.env.REACT_APP_API_URL}` + image;
              }}
            />

            <label
              htmlFor="file-upload"
              className="cursor-pointer absolute bottom-10"
            >
              <img src="/images/settings/upload2.png" alt="Upload Icon" />
            </label>

            <input
              id="file-upload"
              type="file"
              className="hidden"
              onChange={(e) => handleFileUpload(e)}
            />
          </div>

          <div className="flex flex-col gap-3">
            {/* معلوماتك الشخصية */}
            <div className="px-[10px] pb-[20px]">
              <span className="text-[16px] font-bold text-[#444444]">
                معلوماتك الشخصية
              </span>
              <div className="flex flex-col gap-[7px] mt-[10px]">
                <div className="border-[1px] border-[#DDDDDD] rounded-md flex flex-col sm:flex-row">
                  <div className="py-[12px] px-[20px] font-bold bg-[#FAFAFA] sm:w-[16vw] border-l-[1px] border-[#EEEEEE] rounded-md">
                    <span className="text-[#666666] text-[14px]">
                      الاسم الكريم
                    </span>
                  </div>
                  <input
                    type="text"
                    value={name}
                    className="w-full py-[12px] px-[20px] border-[1px] border-[#EEEEEE] rounded-e-md"
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="border-[1px] border-[#DDDDDD] rounded-md flex flex-col sm:flex-row">
                  <div className="py-[12px] px-[20px] font-bold bg-[#FAFAFA] sm:w-[16vw] border-l-[1px] border-[#EEEEEE] rounded-md">
                    <span className="text-[#666666] text-[14px]">
                      نبذة عنك{" "}
                    </span>
                  </div>
                  <input
                    type="text"
                    value={bio}
                    onChange={(e) => setBio(e.target.value)}
                    className="w-full py-[12px] px-[20px] border-[1px] border-[#EEEEEE] rounded-e-md"
                  />
                </div>
                <div className="border-[1px] border-[#DDDDDD] rounded-md flex flex-col sm:flex-row">
                  <div className="py-[12px] px-[20px] font-bold bg-[#FAFAFA] sm:w-[16vw] border-l-[1px] border-[#EEEEEE] rounded-md">
                    <span className="text-[#666666] text-[14px]">
                      البريد الالكتروني
                    </span>
                  </div>
                  <input
                    disabled
                    value={user.email}
                    type="text"
                    className="w-full py-[12px] px-[20px] border-[1px] border-[#EEEEEE] rounded-e-md"
                  />
                </div>
              </div>
            </div>

            {/* أضف الروابط الخاصة بك */}
            <div className="px-[10px] pb-[20px]">
              <span className="text-[16px] font-bold text-[#444444]">
                أضف الروابط الخاصة بك
              </span>
              <div className="flex flex-col gap-[7px] mt-[10px]">
                <div className="border-[1px] border-[#DDDDDD] rounded-md flex flex-col sm:flex-row">
                  <div className="flex gap-2 py-[12px] px-[20px] font-bold bg-[#FAFAFA] sm:w-[16vw] border-l-[1px] border-[#EEEEEE] rounded-md">
                    <img
                      src="/images/settings/salla.svg"
                      alt="salla"
                      className="w-[19px] h-[19px]"
                    />
                    <span className="text-[#666666] text-[14px]">
                      اسم متجرك
                    </span>
                  </div>
                  <input
                    type="text"
                    value={sallaStoreName}
                    onChange={(e) => setSallaStoreName(e.target.value)}
                    className="w-full py-[12px] px-[20px] border-[1px] border-[#EEEEEE] rounded-e-md"
                  />
                </div>
                <div className="border-[1px] border-[#DDDDDD] rounded-md flex flex-col sm:flex-row">
                  <div className="flex gap-2 py-[12px] px-[20px] font-bold bg-[#FAFAFA] sm:w-[16vw] border-l-[1px] border-[#EEEEEE] rounded-md">
                    <img
                      src="/images/settings/salla.svg"
                      alt="salla"
                      className="w-[19px] h-[19px]"
                    />
                    <span className="text-[#666666] text-[14px]">
                      رابط متجرك
                    </span>
                  </div>
                  <input
                    type="text"
                    value={sallaStoreUrl}
                    onChange={(e) => setSallaStoreUrl(e.target.value)}
                    className="w-full py-[12px] px-[20px] border-[1px] border-[#EEEEEE] rounded-e-md"
                  />
                </div>
                <div className="border-[1px] border-[#DDDDDD] rounded-md flex flex-col sm:flex-row">
                  <div className="flex gap-2 py-[12px] px-[20px] font-bold bg-[#FAFAFA] sm:w-[16vw] border-l-[1px] border-[#EEEEEE] rounded-md">
                    <img
                      src="/images/settings/x.svg"
                      alt="twitter"
                      className="w-[19px] h-[19px]"
                    />
                    <span className="text-[#666666] text-[14px]">
                      إكس (تويتر سابقاً)
                    </span>
                  </div>
                  <input
                    type="text"
                    value={twitter}
                    onChange={(e) => setTwitter(e.target.value)}
                    className="w-full py-[12px] px-[20px] border-[1px] border-[#EEEEEE] rounded-e-md"
                  />
                </div>
                <div className="border-[1px] border-[#DDDDDD] rounded-md flex flex-col sm:flex-row">
                  <div className="flex gap-2 py-[12px] px-[20px] font-bold bg-[#FAFAFA] sm:w-[16vw] border-l-[1px] border-[#EEEEEE] rounded-md">
                    <img
                      src="/images/settings/insta.svg"
                      alt="insta"
                      className="w-[19px] h-[19px]"
                    />
                    <span className="text-[#666666] text-[14px]">انستجرام</span>
                  </div>
                  <input
                    type="text"
                    value={instagram}
                    onChange={(e) => setInstagram(e.target.value)}
                    className="w-full py-[12px] px-[20px] border-[1px] border-[#EEEEEE] rounded-e-md"
                  />
                </div>
                <div className="border-[1px] border-[#DDDDDD] rounded-md flex flex-col sm:flex-row">
                  <div className="flex gap-2 py-[12px] px-[20px] font-bold bg-[#FAFAFA] sm:w-[16vw] border-l-[1px] border-[#EEEEEE] rounded-md">
                    <img
                      src="/images/settings/tiktok.svg"
                      alt="tiktok"
                      className="w-[19px] h-[19px]"
                    />
                    <span className="text-[#666666] text-[14px]">تيك توك</span>
                  </div>
                  <input
                    type="text"
                    value={tiktok}
                    onChange={(e) => setTiktok(e.target.value)}
                    className="w-full py-[12px] px-[20px] border-[1px] border-[#EEEEEE] rounded-e-md"
                  />
                </div>
                <div className="border-[1px] border-[#DDDDDD] rounded-md flex flex-col sm:flex-row">
                  <div className="flex gap-2 py-[12px] px-[20px] font-bold bg-[#FAFAFA] sm:w-[16vw] border-l-[1px] border-[#EEEEEE] rounded-md">
                    <img
                      src="/images/settings/clip.svg"
                      alt="clip"
                      className="w-[19px] h-[19px]"
                    />
                    <span className="text-[#666666] text-[14px]">الموقع</span>
                  </div>
                  <input
                    type="text"
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                    className="w-full py-[12px] px-[20px] border-[1px] border-[#EEEEEE] rounded-e-md"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="flex sm:justify-end justify-center cursor-pointer"
            onClick={() => {
              updateUserDetails();
            }}
          >
            <button className="btn flex justify-center py-[12px] items-center bg-[#BAF3E6] sm:w-[81px] w-full mx-4 sm:mx-0 rounded-md">
              حفظ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
